import React, { useEffect, useState } from "react";
import { addMinutes, differenceInSeconds, parseISO } from "date-fns";
import { makeStyles } from 'tss-react/mui';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles()({
    clock: {
        fontSize: "large",
        alignItems: "center",
    },
    redClock: {
        fontSize: "large",
        fontWeight: "bold",
        color: "#F44336",
    },
});

type ClockProps = {
    startTime: string;
    now: string;
    duration: number;
    onTimeElapsed: () => void;
    solutionIsBeingSent: boolean;
};

export function Clock(props: ClockProps) {
    const { now, startTime, duration, onTimeElapsed, solutionIsBeingSent } =
        props;

    const [secondsLeftForTask, setSecondsLeftForTask] = useState(() => {
        const _now = parseISO(now);
        const _startTime = parseISO(startTime);
        return calculateSecondsLeftForTask(_now, _startTime, duration);
    });
    const [timeIsRunningOut, setTimeIsRunningOut] = useState(false);
    const [intervalId, setIntervalId] = useState(0);

    const { classes, cx } = useStyles();
    const timeLimitForWarning = 60;

    const { t } = useTranslation()

    useEffect(() => {
        if (secondsLeftForTask <= 0) {
            onTimeElapsed();
        }

        setTimeIsRunningOut(secondsLeftForTask <= timeLimitForWarning);
    }, [secondsLeftForTask, onTimeElapsed]);

    useEffect(() => {
        const endTime = addMinutes(parseISO(startTime), duration);
        setIntervalId(
            window.setInterval(() => {
                setSecondsLeftForTask(
                    Math.max(differenceInSeconds(endTime, new Date()), 0)
                );
            }, 1000)
        );
    }, [duration, startTime]);

    // HACK: to use an effect to cause the clock to clear its interval feels a little hacky;
    //       maybe this should exposed to parent components via a ref?
    useEffect(() => {
        if (solutionIsBeingSent) window.clearInterval(intervalId);
    }, [solutionIsBeingSent, intervalId]);

    return (
        <div
            className={
                timeIsRunningOut
                    ? cx(classes.clock, classes.redClock)
                    : classes.clock
            }
        >
            <p>
                {t("codeAssignmentPage:timeLeftForTask", {
                    minutes: getMinutes(secondsLeftForTask),
                    seconds: getSeconds(secondsLeftForTask),
                })}
            </p>
        </div>
    );
}

function getSeconds(time: number) {
    const sec = time % 60;
    return sec > 9 ? sec.toString() : "0" + sec.toString();
}

function getMinutes(time: number) {
    const min = Math.floor(time / 60);
    return min > 9 ? min.toString() : "0" + min.toString();
}

function calculateSecondsLeftForTask(
    now: Date,
    startTime: Date,
    minutes: number
) {
    return differenceInSeconds(addMinutes(startTime, minutes), now);
}
